import React from 'react';
import AView from 'antd-mobile/lib/view';



export default class View extends AView {}